import { useEffect, useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const PATTERNS = [
  [/(?:penambahan pulsa|menerima pulsa senilai)\s*Rp\.?\s*([\d.,]+)\s*dari\s*(?:nomor\s*)?\+?(\d{8,15})/i, 1, 2],
  [/menerima (?:transfer )?pulsa dari\s*(?:nomor\s*)?\+?(\d{8,15})\s*sebesar\s*(?:Rp\.?\s*)?([\d.,]*\d)/i, 2, 1],
];

export function parseTopup(text) {
  for (const [re, a, f] of PATTERNS) {
    const m = (text || "").match(re);
    if (m) return { amount: m[a].replace(/,\d{2}$/, "").replace(/[.,]/g, ""), from: m[f] };
  }
  return null;
}

const OLD_KEY = "sms_copied";
(function migrateOldMarks() {
  const ids = JSON.parse(localStorage.getItem(OLD_KEY) || "[]");
  if (!ids.length) return;
  const chunks = [];
  for (let i = 0; i < ids.length; i += 500) chunks.push(ids.slice(i, i + 500));
  Promise.all(chunks.map((c) => api.post("/sms/copied", { ids: c })))
    .then(() => localStorage.removeItem(OLD_KEY)).catch(() => {});
})();

const topupLine = (m) => {
  const p = parseTopup(m.text);
  return `${m.sim_name || ""}\t\t${p.from}\t${p.amount}`;
};

async function writeClip(s) {
  try {
    await navigator.clipboard.writeText(s);
  } catch {
    const t = document.createElement("textarea");
    t.value = s;
    document.body.appendChild(t);
    t.select();
    document.execCommand("copy");
    t.remove();
  }
}

export function CopyTopup({ m }) {
  const [copied, setCopied] = useState(!!m.copied_at);
  useEffect(() => setCopied(!!m.copied_at), [m.copied_at]);
  const p = m.direction !== "out" && parseTopup(m.text);
  if (!p) return <span />;
  const copy = async () => {
    await writeClip(topupLine(m));
    setCopied(true);
    api.post("/sms/copied", { ids: [m.id] }).catch(() => toast.error("Tanda salin gagal disimpan ke server"));
    toast.success(`Disalin: ${m.sim_name || "tanpa nama"} · ${p.from} · ${Number(p.amount).toLocaleString("id-ID")}`);
  };
  const tip = copied ? `Sudah disalin${m.copied_by ? ` oleh ${m.copied_by}` : ""} (klik untuk salin lagi)` : "Salin untuk WPS";
  return (
    <button data-testid={`sms-copy-${m.id}`} onClick={copy} title={tip}
      className={`self-center h-8 w-8 inline-flex items-center justify-center rounded-md border transition-colors ${copied ? "border-sky-300 bg-sky-50 text-sky-700" : "border-emerald-500 text-emerald-700 hover:bg-emerald-50"}`}>
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
    </button>
  );
}
